import { Typography } from '@mui/material';
import React from 'react';
import StyledTextareaAutosize from './styled-text-area-field';

interface ITextAreaFieldControlProps {
  value: string;
  handleChange: (value: string) => void;
  handleBlur: (value: React.FocusEvent) => void;
  label: string;
  // eslint-disable-next-line react/require-default-props
  error?: string;
  // eslint-disable-next-line react/require-default-props
  isDisabled?: boolean;
}

export default function TextAreaFieldControl({
  handleChange,
  handleBlur,
  label,
  value,
  isDisabled = false,
  error = ''
}: ITextAreaFieldControlProps) {
  return (
    <>
      <StyledTextareaAutosize
        sx={{
          width: '100%',
          resize: 'vertical',
          fontSize: '10px',
          maxHeight: '150px',
          padding: '10px',
          minHeight: '30px',
          fontFamily:
            'MarsCentra,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol",system-ui'
        }}
        id={label}
        disabled={isDisabled}
        value={value}
        onChange={(e) => handleChange(e.target.value)}
        onBlur={(e) => handleBlur(e)}
      />
      {error ? (
        <Typography fontSize='8px' color='red'>
          {error}
        </Typography>
      ) : null}
    </>
  );
}
